// https://vuetifyjs.com/en/components/lazy/
import Toggleable from 'vuetify/lib/mixins/toggleable';
import intersect from 'vuetify/lib/directives/intersect';
import mixins from 'vuetify/lib/util/mixins';

import {
  convertToUnit,
  getSlot,
} from 'vuetify/lib/util/helpers';

export default mixins(Toggleable).extend({
  name: 'VirtualWrapper',
  directives: {
    intersect,
  },
  props: {
    minHeight: [Number, String],
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: () => ({
        root: undefined,
        rootMargin: undefined,
        threshold: undefined,
      }),
    },
    tag: {
      type: String,
      default: 'div',
    },
    transition: {
      type: String,
      default: 'fade-transition',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      return {
        minHeight: parseInt(this.minHeight, 10) ? convertToUnit(this.minHeight) : this.minHeight,
      };
    },
  },
  methods: {
    genContent() {
      const slot = getSlot(this);
      /* istanbul ignore if */

      if (!this.transition) return slot;
      const children = [];
      if (this.isActive) children.push(slot);
      return this.$createElement('transition', {
        props: {
          name: this.transition,
        },
      }, children);
    },

    onObserve(entries, observer, isIntersecting) {
      this.isActive = isIntersecting;
    },

  },

  render(h) {
    return h(this.tag, {
      staticClass: 'v-lazy',
      attrs: this.$attrs,
      directives: [{
        name: 'intersect',
        value: {
          handler: this.onObserve,
          options: this.options,
        },
      }],
      on: this.$listeners,
      style: this.styles,
    }, [this.genContent()]);
  },

});
